import { IApplicationState } from 'setup/store'

export const selectProfileInfo = (state: IApplicationState) => state.profile.data
export const selectProfileCommunication = (state: IApplicationState) => state.profile.communications

export const selectForceChangePasswordCommunication = (state: IApplicationState) =>
  state.profile.communications.forceChangePassword